import { gzipSync, strToU8 } from 'fflate';

export function compressData(data, options = {}) {
    const { level = 1 } = options;

    const jsonString = JSON.stringify(data);
    const uint8Array = strToU8(jsonString);

    const gzippedData = gzipSync(uint8Array, { level });

    return gzippedData;
}
